import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getParentEdgeTypeId, getSimpleBranchingQuery } from '@iotv/datamodel-core';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { getAdjacent2Wrapper } from '../../../data/daoFunctions/daoFunctions';
import { extractViewObjectFromNodeEdgeMapper } from '../../../data/daoFunctions/nodeEdgeMapperTransform';
import { getApexPartnerGroup } from '../../../helpers/queryHelpers';
import { useTabHandlerStringKeys } from '../../../hooks/useTabHandler';
import { getRegionContextQuery } from '../../../QueryDefinitions/region';
import { AdjacentType, Severity } from '../../../types/AppTypes';
import { Listerlizer } from '../../factories/Listerlizer/Listerlizer';
import { PartnerViewDefinition } from '../../Partner/viewDefinitions';
import { AutoTab } from '../AutoTab';
import { getAreaViewDefinition, getPlaceViewDefinition, getPropertyViewDefinition } from '../viewDefinitions';
import { RegionDetail } from './RegionDetail';
const debug = process.env.REACT_APP_DEBUG && false;
export const RegionView = (props) => {
    const region = props.viewObject.matchedPrimary;
    const { transactionFunctions, userFunctions, contextCustomer, applicationData, allowedActions } = props;
    const viewObject = region && applicationData
        ? extractViewObjectFromNodeEdgeMapper(applicationData, region)
        : { matchedPrimary: region, matchedRelatedByPk: [], matchedRelatedBySk: [] };
    const getRegionContext = async (region) => {
        /* Temp test querying application data as this should have Region after init
         * but it wont have all the properties!!!! - only properties of the current context customer ?
         * Doesn't matter cos properties will auto query anyway
         * */
        const data = applicationData?.applyBranchingQuery([region], getRegionContextQuery());
        // if ( err ) { userFunctions.setUserMessage( { content: `${err.message}`, id: v4(), label: '', type:'MessageBar', severity: Severity.error})}
        if (data) {
            debug && console.log('getRegionContext returned', data.getContainedNodesAndEdges());
            debug && console.log('getRegionContext nem has context object', !!data.getItem(region), data.getItem(region));
            userFunctions.addObjectsToState(data.getContainedNodesAndEdges());
        }
    };
    useEffect(() => {
        if (!region)
            return;
        getRegionContext(region);
    }, [region?.sk]);
    /** Get partner apex group (for partner linking) */
    const [apexPartners, setApexPartners] = useState(undefined);
    useEffect(() => {
        getApexPartnerGroup().then((pg_res) => {
            if (pg_res.err || !pg_res.data) {
                userFunctions.setUserMessage({
                    id: v4(),
                    type: 'MessageBar',
                    label: 'Failed to find partners',
                    content: 'Failed to find partners. Please check developer console for more details.',
                    severity: Severity.error,
                });
                return;
            }
            setApexPartners(pg_res.data);
        });
    }, []);
    /** Get most proximate customer */
    const [mpc, setMpc] = useState(undefined);
    useEffect(() => {
        if (!region)
            return;
        const request = {
            scopeDefinitingContextObject: region,
            adjacencyType: AdjacentType.PARENT,
            objectTypeId: 'Customer',
            edgeTypeId: getParentEdgeTypeId('Property', 'Customer'),
        };
        getAdjacent2Wrapper(request).then((res) => {
            debug && console.log('PropertyView res 2', res);
            if (res.data?.Items && res.data.Items[0]) {
                setMpc(res.data.Items[0]);
                console.log(res.data.Items[0]);
            }
        });
    }, [region?.sk]);
    /** Table Set Up */
    const tabDefs = [
        {
            label: 'Details',
            value: 'Details',
            component: region ? _jsx(RegionDetail, { contextObject: region, transactionFunctions, userFunctions, allowedActions }) : _jsx(_Fragment, {}),
        },
        { direction: AdjacentType.CHILD, label: 'Sub Regions', value: 'subregions', type: 'Region' },
        { direction: AdjacentType.CHILD, label: 'Properties', value: 'Properties', type: 'Property' },
        {
            label: 'Linked Partners',
            value: 'Partners',
            component: applicationData ? (_jsx(Listerlizer, { viewObject: {
                    matchedPrimary: region,
                    matchedRelatedByPk: [],
                    matchedRelatedBySk: [],
                }, adjacentFilter: {
                    objectType: 'Partner',
                    adjacentType: AdjacentType.CHILD,
                }, userFunctions: userFunctions, transactionFunctions: transactionFunctions, viewDefinition: PartnerViewDefinition, contextObject: contextCustomer, applicationData: applicationData, searchRootObjects: apexPartners ? [apexPartners] : undefined, linkableItemsViewDefinition: PartnerViewDefinition, linkableItemsBranchingQueryDefinition: getSimpleBranchingQuery('Group', 'Partner', AdjacentType.CHILD) })) : (_jsx(_Fragment, {})),
        },
    ];
    const tabKeyMap = Object.fromEntries(tabDefs.map((t) => [t.value, t]));
    const { state: [[value, setValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabKeyMap);
    const typesToViewDefs = {
        Property: getPropertyViewDefinition(),
        Area: getAreaViewDefinition(),
        Place: getPlaceViewDefinition(),
    };
    return (_jsxs(TabContext, { value: value, children: [_jsx(TabList, { onChange: handleTabChange, children: tabDefs.map((tabDef, i) => (_jsx(Tab, { value: tabDef.value, label: tabDef.label, disabled: false }, `tabHeader_${i}`))) }), tabDefs
                .filter((c) => c !== null)
                .map((tabDef, index) => (_jsx(TabPanel, { value: tabDef.value, sx: { padding: 0, paddingBlockStart: 1 }, children: region && (_jsx(AutoTab, { tabDef: tabDef,
                    mostProximateCustomer: mpc,
                    contextCustomer,
                    contextObject: region,
                    viewObject,
                    userFunctions,
                    transactionFunctions,
                    viewDefinitionIn: typesToViewDefs[tabDef.type ?? ''],
                    newObjectDefinition: typesToViewDefs[tabDef.type ?? ''] })) }, `tabBase_${index}`)))] }));
};
